import styled from 'styled-components';

export const StyleTitulo = styled.div`
  background-color: #f6ffed;
  width: 100%;
  margin-bottom: 2rem;
  box-shadow: 0px 0px 0px 24px #f6ffed;

  h1 {
    font-size: 22px;
    line-height: 24px;
    color: rgba(0, 0, 0, 0.85);
    font-weight: 700;
  }

  p {
    font-size: 18px;
    line-height: 22px;
    color: rgba(0, 0, 0, 0.85);
    font-weight: 400;
  }
`;

export const Detalhes = styled.ul`
  list-style: none;
  padding: 0;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 0.5rem;

  div li {
    font-weight: 400;
    font-size: 12px;
    line-height: 20px;
    padding: 10px;

    div:last-child {
      font-weight: 600;
      font-size: 14px;
    }
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;
